export const Tab = 1

export const Button = 2
